import { Flex, Image } from "antd";
import defaultLogo from "assets/paldock_logo-auth.svg";
import { AuthButton } from "components/UI/AuthButton/AuthButton.tsx";
import { PropsWithChildren } from "react";

export type AuthFormWrapperProps = {
    buttonText: string;
    loading?: boolean;
    buttonDisabled?: boolean;
    beforeButton?: React.ReactNode;
    hideLogo?: boolean;
} & PropsWithChildren;

export const AuthFormWrapper: React.FC<AuthFormWrapperProps> = ({
    children,
    buttonText,
    loading = false,
    buttonDisabled = false,
    beforeButton,
    hideLogo = false,
}) => {
    return (
        <div className="flex gap-2 flex-col w-full">
            {!hideLogo && (
                <Flex justify="center" className="my-4">
                    <Image src={defaultLogo} width="75%" preview={false} alt="Logo" />
                </Flex>
            )}
            {children}
            {beforeButton}
            <div className="mt-4">
                <AuthButton loading={loading} disabled={buttonDisabled}>
                    {buttonText}
                </AuthButton>
            </div>
        </div>
    );
};
